/*
 * Copyright (C) 2014 Spanning Cloud Apps.  All rights reserved.
 */
import '../../../restore/columntext/columntext.js';

angular
  .module('batch.objectRestore.details', ['ngSanitize', 'restore.columntext'])
  /**
   * Controller for the admin restore view of the config.user.tpl.html template.
   */
  .controller('ObjectRestoreDetailsCtrl', function ($scope, $filter, TYPES) {
    var currentBatch = $scope.batchUtils.currentBatch,
      batchDate = moment($scope.batchUtils.currentBatch.date),
      hasObjectRestoreData = _.has(currentBatch, 'objectRestoreData'),
      hasFields = hasObjectRestoreData ? _.has(currentBatch.objectRestoreData, 'fields') : false,
      hasAttachments = hasObjectRestoreData ? _.has(currentBatch.objectRestoreData, 'attachments') : false;

    $scope.headerValues = {
      field: 'label'
    };

    $scope.reverse = false;
    $scope.sortBy = $scope.headerValues.field;
    $scope.items = [];
    $scope.attachments = [];
    $scope.showAttachmentInfo = false;

    $scope.restored = hasFields ? currentBatch.objectRestoreData.fields.restored : false;
    $scope.items = hasFields ? currentBatch.objectRestoreData.fields.diffs : [];

    $scope.attachments = hasAttachments ? currentBatch.objectRestoreData.attachments.diffs : [];

    $scope.name = currentBatch.objectRestoreData.objectName;
    // Set the type of object for this restore
    $scope.type = currentBatch.objectRestoreData.objectType;
    // Different CSS classes used to display the appropriate icon in the view
    $scope.TYPES = TYPES;

    /**
     * Returns boolean whether to show up or down arrow for header.
     * @param header - The header value.
     * @returns {string} The class to use..
     */
    $scope.isSelectedHeader = function (header) {
      var headerClass = '';
      if ($scope.sortBy === header) {
        if ($scope.reverse) {
          headerClass = 'sbsf-log-header-desc sca-icon-down-black';
        } else {
          headerClass = 'sbsf-log-header-asc sca-icon-down-black';
        }
      }
      return headerClass;
    };

    /**
     * Sets the sort parameter to the header selected.
     * @param {String} header - The header value and property to sort by.
     */
    $scope.selectHeader = function (header) {
      $scope.reverse = !$scope.reverse;
      $scope.sortBy = header;
    };

    /**
     * Provides the previous version header text.
     *
     * @returns {String} - The previous version header text.
     */
    $scope.getPreviousVersionMsg = function () {
      return $filter('i18n')('RESTORED_VERSION_DATE', batchDate.format($filter('i18n')('M_D_Y')));
    };

    /**
     * Provides the current version header text.
     *
     * @returns {String} - The current version header text.
     */
    $scope.getCurrentVersionMsg = function () {
      return $filter('i18n')('PREVIOUS_VERSION');
    };

    /**
     * Provides the message for specifying the number of differences.
     *
     * @returns {String} - The differences text.
     */
    $scope.getDifferencesText = function () {
      var count = $scope.items.length + $scope.attachments.length,
        changeStr = $filter('pluralize')(count, 'ONE_CHANGE', 'CHANGES');

      return $filter('i18n')('CHANGES_FROM', [changeStr, batchDate.format($filter('i18n')('M_D_Y_H_M'))]);
    };

    /**
     * Provides the header string for the attachments section.
     *
     * @returns {string} - The header string for attachments.
     */
    $scope.getAttachmentHeader = function () {
      return $filter('i18n')('RESTORED_VERSION');
    };
  });
